import { EventImportStatus } from '../infra/dtos';

const STATUS_COLORS = {
  success: { backgroundColor: 'rgba(16, 185, 129, 0.08)', color: '#10b981' },
  warning: { backgroundColor: 'rgba(245, 158, 11, 0.08)', color: '#f59e0b' },
  error: { backgroundColor: 'rgba(239, 68, 68, 0.08)', color: '#ef4444' },
};

export function useImportStatusColors() {
  return {
    [EventImportStatus.Completed]: STATUS_COLORS.success,
    [EventImportStatus.Pending]: STATUS_COLORS.warning,
    [EventImportStatus.Processing]: STATUS_COLORS.warning,
    [EventImportStatus.Failed]: STATUS_COLORS.error,
  };
}
